<p-dialog [header]="isEditMode ? 'Edit Comment Category' : 'Add Comment Category'"
    [(visible)]="displayCreateUpdateCommentCategory" [modal]="true" *ngIf="displayCreateUpdateCommentCategory"
    [responsive]="true" [style]="{width: '60vw'}" (onHide)="onHideCategoryModal()">

    <form [formGroup]="commentCategoryForm">
        <div class="header">
            <h5>{{ isEditMode ? 'Edit Comment Category Information' : 'Add Comment Category Information' }}</h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label for="name">Category Name<span style="color: red;">*</span></label>
                    <input type="text" pInputText formControlName="name">
                    <div *ngIf="commentCategoryForm.get('name').touched && commentCategoryForm.get('name').errors?.['required']"
                    class="p-error p-mt-1">
                    Category name is required.
                </div>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Category Color <span style="color: red;">*</span></label>
                    <p-colorPicker appendTo="body" formControlName="color" class="p-mt-1 p-ml-1"></p-colorPicker>
                    <div *ngIf="commentCategoryForm.get('color').touched && commentCategoryForm.get('color').errors?.['required']"
                    class="p-error p-mt-1">
                    Category color is required.
                </div>
                </div>
                <ng-container *ngIf="showParentCategory">
                    <div class="p-col-12 p-md-6">
                        <label for="parentCategory">Parent Category</label>
                        <p-dropdown [options]="commentCategories" optionLabel="name" optionValue="id"
                            formControlName="parentId" placeholder="Select Parent Category" [showClear]="true" appendTo="body">
                        </p-dropdown>
                    </div>
                </ng-container>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="onHideCategoryModal()" label="Cancel" class="p-button-secondary">
        </button>
        <button type="button" pButton
            (click)="createUpdateCommentCategory(commentCategoryForm.value)"
            label="{{ isEditMode ? 'Update' : 'Save' }}">
        </button>
    </p-footer>
</p-dialog>